import { render, staticRenderFns } from "./ConfigContract.vue?vue&type=template&id=6cf66892&scoped=true&"
import script from "./ConfigContract.vue?vue&type=script&lang=js&"
export * from "./ConfigContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf66892",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCol,VRow,VTextField})
